import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dc8a7de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-input-container" }
const _hoisted_2 = {
  key: 0,
  class: "c-input-label"
}
const _hoisted_3 = { class: "c-input-label-txt" }
const _hoisted_4 = { class: "c-input-box" }
const _hoisted_5 = ["type", "value", "placeholder"]
const _hoisted_6 = {
  key: 1,
  class: "c-input-error"
}

import { onMounted, reactive } from "vue";
import { emitter } from '@/utils/eventBus'
interface RullProp {
  required?: boolean
  message: string
}
// TS 别名
// 定义验证规则数组的数据类型
type RulesProp = RullProp[];

interface InputProps {
  type?: string,
  value?: string | number
  label?: string,
  placeholder?: string,
  inputStyle?: object,
  showSearch?: boolean,
  rules?: RulesProp,
}

const __default__ = {
  name: 'CInput'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    type: { default: 'text' },
    value: null,
    label: null,
    placeholder: null,
    inputStyle: null,
    showSearch: { type: Boolean, default: false },
    rules: null
  },
  emits: ['update:value', 'focus', 'blur', 'input', 'enter'],
  setup(__props: any, { emit }) {

const props = __props as { type: string, value?: string | number, label?: string, placeholder?: string, inputStyle?: object, showSearch: boolean, rules?: RulesProp };





const state = reactive({
  message: '',
  error: false,
  required: false,
})

const onInput = (e) => {
  // console.log(e.target.value)
  emit('update:value', e.target.value)
  emit('input', e.target.value)
}
const onBlur = () => {
  validateInput()
  emit('blur')
}
const onFocus = () => {
  emit('focus')
}
const onEnter = (e) => {
  // console.log(e.keyCode,e.target.value)
  if (e.keyCode == 13) {
    emit('enter', e.target.value)
  }

}
const validateInput = (): boolean => {
  // 接收从父组件传递过来的验证规则（数组类型）
  if (props.rules) {
    // 调用数组的 every 方法，判断是否符合定义的表单验证规则
    const allPassed = props.rules.every(rule => {
      // 表单是否通过验证的标志
      let passed = true
      // 先将规则的提示信息赋值，如果表单验证失败，则会直接获得该message信息
      // 因为 every 只要有一个错误 就会返回错误，且其他数组不会再进行判断
      state.message = rule.message
      if (rule.required) {
        if (props.value) {
          passed = props.value?.toString().trim() !== ''
        } else {
          passed = false
        }
        // console.log(props.value)
      }
      // console.log(passed)
      return passed
    })
    // 如果表单验证失败，则 allPassed 状态为 false 但是 state 对象中的 error应为 true
    // 所以 allPassed 取反赋值
    state.error = !allPassed
    // validateInput 方法的返回结果
    return allPassed
  }
  // 如果没有 props.rules 的表单规则 则返回 true
  return true
};
onMounted(() => {
  if (props.rules) {
    props.rules?.every(rule => {
      if (rule.required) {
        state.required = true
      }
    })
    emitter.emit("formItemCreated", validateInput)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (state.required)
            ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                class: "require-icon",
                icon: "require"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label) + ": ", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        type: __props.type,
        class: "c-input-control",
        value: __props.value,
        placeholder: __props.placeholder,
        style: _normalizeStyle({ ...__props.inputStyle }),
        onInput: onInput,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeydown: onEnter
      }, null, 44, _hoisted_5),
      (__props.showSearch)
        ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            class: "c-input-search-icon",
            icon: "search"
          }))
        : _createCommentVNode("", true),
      (state.error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(state.message), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})